import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { BillingAccountsNavEn, BillingAccountsNavSp } from '../../../global/constants/navigation-lists';
import { TcsmStates } from '../../../root/tcsm-model';
import { ArcRoutes } from '../constants/routes';
import { Group } from '../features/groups/groups-model';
import { SearchProps } from '../models/arc-epi-props';

interface GroupInfoSectionProps {
	groupId: number,
	basePath: string,
}
const HideIdList = ['ECCC1', 'ECCC2', 'ECCC3'];
export const GroupInfoSection = (props: GroupInfoSectionProps) => {
	const currentGroup = useSelector<TcsmStates, Group>(state => state.groupsState?.currentGroup);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const location = useLocation();
	const pathName = location.pathname.toLocaleLowerCase();
	const navOptions = language === 'en' ? BillingAccountsNavEn(`${props.basePath}${ArcRoutes.BillingAccountsSearch}`) : BillingAccountsNavSp(`${props.basePath}${ArcRoutes.BillingAccountsSearch}`);

	if (!props.groupId ||
		location?.pathname?.includes(ArcRoutes?.Participants) ||
		!location.pathname?.includes(props.basePath) ||
		// Ignore BillingAccounts Nav options.
		(navOptions.some(a => pathName === a.value?.toLocaleLowerCase() || pathName === a.fallbackMatch?.toLocaleLowerCase()))) return null;


	return (
		<div>
			<h4>{currentGroup?.name}</h4>
			<p>{searchSettings?.billingAccountGroupIdLabel}: {currentGroup?.group_id}</p>
			{!HideIdList.includes(currentGroup?.name) && <p>{searchSettings?.clientIdLabel}: {currentGroup?.client_number}</p>}
		</div>
	);
};